var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:({ callback: _vm.isViewableNow, once: false }),expression:"{ callback: isViewableNow, once: false }"}]},[_vm._v(" "+_vm._s(_vm.animatedNumber)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }